import { Button, FormField } from "@commerce-os/ui";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useId, useState } from "react";

import { useApp } from "../../app/context";
import { useT } from "../../app/i18n";

export const Route = createFileRoute("/_auth/support-sign-in")({ component: SupportSignInPage });

/**
 * SA-16: commerce-os support opens a business with the token the Super Admin issued while the owner's grant is valid.
 * The token stays in memory like any access token; when it ends (or the owner revokes access) the session ends.
 */
function SupportSignInPage() {
  const { t } = useT();
  const { session } = useApp();
  const navigate = useNavigate();
  const id = useId();
  const [token, setToken] = useState("");
  return (
    <>
      <h1 className="mb-2 text-xl font-semibold">{t("support:signIn.title")}</h1>
      <p className="mb-6 text-sm text-muted-foreground">{t("support:signIn.body")}</p>
      <form
        className="flex flex-col gap-4"
        onSubmit={(event) => {
          event.preventDefault();
          if (token.trim() === "") return;
          session.setToken(token.trim());
          void navigate({ to: "/" });
        }}
      >
        <FormField label={t("support:signIn.token")} htmlFor={id}>
          <textarea
            id={id}
            autoComplete="off"
            spellCheck={false}
            className="min-h-28 rounded-md border border-input bg-card px-3 py-2 font-mono text-xs shadow-xs focus-visible:ring-2 focus-visible:ring-ring focus-visible:outline-none"
            value={token}
            onChange={(event) => {
              setToken(event.target.value);
            }}
          />
        </FormField>
        <Button type="submit" disabled={token.trim() === ""}>
          {t("support:signIn.submit")}
        </Button>
      </form>
    </>
  );
}
